import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api, setJwt } from '../lib/api';
import { Button } from '../components/Button';

export function DevLogin() {
  const [name, setName] = useState('Pundit Dev');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const qc = useQueryClient();
  const nav = useNavigate();

  async function login() {
    setBusy(true);
    setErr(null);
    try {
      const id = Math.floor(Math.random() * 90_000_000) + 10_000_000;
      const { token } = await api.authDev(id, name || 'Dev');
      await setJwt(token);
      await qc.invalidateQueries({ queryKey: ['me'] });
      nav('/', { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md px-4 pt-10 space-y-4">
      <div className="font-display text-3xl uppercase tracking-wide">Dev login</div>
      <div className="text-text-dim text-sm">
        Browser-only fallback when you're not opening this in Telegram. Requires the API Worker
        to be running with <code className="font-mono text-trophy-gold">ENVIRONMENT=development</code>.
      </div>
      <div className="rounded-xl border border-border-base bg-bg-card p-4 space-y-3">
        <label className="block">
          <span className="font-display-alt text-xs uppercase tracking-widest text-text-faint">
            Display name
          </span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 w-full rounded-lg bg-bg-night border border-border-base px-3 py-2 text-text-base outline-none focus:border-trophy-gold"
          />
        </label>
        <Button variant="gold" fullWidth onClick={login} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
        {err && <div className="text-crimson text-sm">{err}</div>}
      </div>
    </div>
  );
}
